import React from 'react'
import Manager from '../../public/components/Manager'
import JudgeStandardApplyDetail from './JudgeStandardApplyDetail'
Ext.require('Ext.Toast')

const config = {
	buttons: [
	],
	columns: [
		{ _text: '申请编号', field: 'Number', minWidth: 150, search: true, },
		{ _text: '申请类型', field: 'ApplyType', minWidth: 150, flex: 1, filter: true },
		{ _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, align: 'left' },
		{ _text: '申请人', field: 'Creator', minWidth: 150, search: true, },
		{ _text: '判定标准', field: 'JudgeStandard', minWidth: 250, flex: 2, search: true, },
	],
	onDoubleTap: ({ showDetail, refreshPage }, data) => {
		showDetail(props => <JudgeStandardApplyDetail {...props} id={data.id} />)
	}
}

export default props => <Manager {...props} config={config} />